import { cusAxios, PREFIX } from './main';

const getProviderSource = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/provider/source_list`
  });
  return response;
};

const getProviders = async ({ sourceId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/provider/provider_list`,
    data: { sourceId }
  });
  return response;
};

const setProviderOption = async ({
  provider,
  sourceId,
  percent,
  enabled,
  providerList,
  customName
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/provider/set_option`,
    data: { provider, sourceId, percent, enabled, providerList, customName }
  });
  return response;
};

export const API_SETTING = {
  provider: {
    list: getProviders,
    option: { set: setProviderOption },
    source: { list: getProviderSource }
  }
};
